var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-nav-item-dropdown",
    {
      staticClass: "dropdown-notification mr-25",
      attrs: { "menu-class": "dropdown-menu-media", right: "" },
      scopedSlots: _vm._u([
        {
          key: "button-content",
          fn: function () {
            return [
              _c("feather-icon", {
                staticClass: "text-body",
                attrs: {
                  badge: _vm.TotalCount,
                  "badge-classes": "bg-danger",
                  icon: "BellIcon",
                  size: "21",
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("li", { staticClass: "dropdown-menu-header" }, [
        _c(
          "div",
          { staticClass: "dropdown-header d-flex" },
          [
            _c("h4", { staticClass: "notification-title mb-0 mr-auto" }, [
              _vm._v("Notifications"),
            ]),
            _c("b-badge", { attrs: { pill: "", variant: "light-primary" } }, [
              _vm._v(" " + _vm._s(_vm.TotalCount) + " "),
            ]),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "scrollable-container media-list scroll-area",
          attrs: { tagname: "li" },
        },
        [
          _c("div", { staticClass: "media d-flex align-items-center" }, [
            _c("h6", { staticClass: "font-weight-bolder mr-auto mb-0" }, [
              _vm._v("Alerts"),
            ]),
          ]),
          _vm.loading
            ? _c(
                "div",
                { staticClass: "d-flex justify-content-center my-1" },
                [
                  _c("b-spinner", {
                    staticStyle: { width: "3rem", height: "3rem" },
                    attrs: { variant: "success", label: "Spinning", block: "" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._l(_vm.sortedNotifications, function (notifications, index) {
            return !_vm.loading
              ? _c(
                  "b-link",
                  { key: notifications.id },
                  [
                    _c(
                      "b-media",
                      {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "aside",
                              fn: function () {
                                return [
                                  _c(
                                    "b-avatar",
                                    {
                                      attrs: { size: "32", variant: "success" },
                                    },
                                    [
                                      _c("feather-icon", {
                                        attrs: { icon: "AlertCircleIcon" },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center",
                          },
                          [
                            _c("div", [
                              _c("p", { staticClass: "media-heading" }, [
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bolder" },
                                  [
                                    _vm._v(
                                      " " + _vm._s(notifications.title) + " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "notification-text text-danger fw-bold",
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(notifications.subTitle) + " "
                                  ),
                                ]
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center" },
                              [
                                notifications.url
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass: "ml-2",
                                        attrs: {
                                          variant: "success",
                                          size: "sm",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openUrl(
                                              notifications.url
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" View ")]
                                    )
                                  : _vm._e(),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "btn-icon rounded-circle ml-2",
                                    attrs: { variant: "flat-danger" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.deletePushNotification(
                                          notifications.id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("feather-icon", {
                                      attrs: { icon: "XIcon" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e()
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }